<div class="modal-header">
    <h5 class="pt-3" style="padding-left:2rem">Material</h5>
    <button type="button" class="btn-close me-4" mat-dialog-close></button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
    <div class="modal-body">
        <div class="row g-4">
            <div class="col-md-6 mt-0">

                <mat-card class="info-card2 mt-3">
                    <mat-card-content class="info-gen">
                        <div class="d-flex justify-content-between align-items-center">
                            <h6><b>Información general</b></h6>
                        </div>
                        <mat-divider></mat-divider>
                        <div class="mt-2 d-flex justify-content-between">
                            <span>Línea</span><span><b>{{dataMat.line}}</b></span>
                        </div>
                        <div class="mt-2 d-flex justify-content-between">
                            <span>Estación</span><span><b>{{dataMat.estacion}}</b></span>
                        </div>
                        <div class="mt-2 d-flex justify-content-between">
                            <span>Posición</span><span><b>Columna {{dataMat.col}} - Fila {{dataMat.row}}</b></span>
                        </div>
                        <div class="mt-2 d-flex justify-content-between">
                            <span>Material</span><span><b>{{dataMat.nombre_mat}}</b></span>
                        </div>
                        <div class="mt-2 d-flex justify-content-between">
                            <span>SKU</span><span><b>{{dataMat.sku}}</b></span>
                        </div>
                        <div class="mt-2 d-flex justify-content-between">
                            <span>Cantidad en inventario</span><span><b>{{dataMat.actual - dataMat.en_linea}}</b></span>
                        </div>
                        <div class="mt-2 d-flex justify-content-between">
                            <span>Cantidad en línea</span><span><b>{{dataMat.en_linea ?? 0}}</b></span>
                        </div>
                        <div class="mt-2 d-flex justify-content-between">
                            <span>Cantidad en rack</span><span><b>{{dataMat.cantidad}}</b></span>
                        </div>
                    </mat-card-content>
                </mat-card>

                <div class="mt-4 ms-2" *ngIf="dataMat.tipo == 'bg' ">
                    <label class="form-label fw-bold">Ingresa {{tipoRelleno}}</label>
                    <input type="number" id="tamano" [(ngModel)]="input_ingresa" class="form-control w-100">
                    <div class="row">
                        <div class="col-md-6">
                            <label class="form-label mt-3" style="font-size: 13px">Material escaneado: </label>
                            <span class="badge rounded-pill custom-bootstrap-badge ms-1">{{dataMat.empacado ??0}}/{{dataMat.cantidad_total}}
                            </span>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label d-flex justify-content-end mt-3 fw-bold">Unidades a ingresar: {{resultadoCantidad}}</label>
                        </div>
                    </div>
                </div>

                <div class="mt-2 ms-2" *ngIf="dataMat.tipo == 'g'">
                    <h6><b>Formulario de reposición</b></h6>
                    <mat-divider></mat-divider>
                    <mat-radio-group class="radio-compact" [(ngModel)]="tipoSeleccionado" (change)="onTipoChange()">
                            <mat-radio-button value="peso" *ngIf="dataMat.peso != null && dataMat.peso != 0">
                                Peso unitario <small>({{dataMat.peso}} kg)</small>
                            </mat-radio-button>
                            <mat-radio-button value="batch">
                                Tamaño de batch <small>({{ dataMat.batch != null && dataMat.batch != 0 ? this.dataMat.batch : 1  }} {{ dataMat.batch == 1 ? 'unidad' : 'unidades'}})</small>
                            </mat-radio-button>
                            <mat-radio-button value="por_unidad">
                                Por unidad
                            </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="col-md-6 mt-3 d-flex align-items-center justify-content-center border image-container">
                
                    <img *ngIf="dataMat.img != null" [src]="dataMat.img" class="img-fluid rounded shadow-sm material-img "
                    style="object-fit: contain;" alt="material" />
                <label *ngIf="dataMat.img == null" class="form-label fw-bold">Sin imagen</label>
                
                
            </div>
        </div>
        <div class="row mt-3 ms-2" >
            <div class="col-md-6">
                <div *ngIf="dataMat.tipo == 'g' ">

                <label class="form-label fw-bold">Ingresa {{tipoRelleno}}</label>
                <input type="number" id="tamano" [(ngModel)]="input_ingresa" class="form-control w-100" (input)="soloEnteros($event)">
                <div class="row">
                    <div class="col-md-6">
                        <label class="form-label mt-2" style="font-size: 13px">Material escaneado: </label>
                        <span class="badge rounded-pill custom-bootstrap-badge ms-1">{{dataMat.empacado ??0}}/{{dataMat.cantidad_total}}
                </span>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label d-flex justify-content-end mt-2 fw-bold">Unidades a ingresar: {{resultadoCantidad}}</label>
                    </div>
                </div>
                </div>

            </div>
            <div class="col-md-6 d-flex justify-content-end mt-5">
                <button mat-flat-button class="bg-success text-white ms-5" (click)="saveRelleno()" type="button">Guardar
                    <mat-icon>save</mat-icon></button>
            </div>
        </div>
    </div>
    <!-- <div class="modal-footer mt-4"></div> -->
</mat-dialog-content>

